import { type AutomationType } from '@repo/utils';

export const getAutomationDetail = `
query AutomationList($filterOptions: JSON) {
  automationList(filterOptions: $filterOptions) {
    automations {
      id
      name
      description
      status
      startsAt
      endsAt
      appearanceType
      updatedAt
      createdAt
      createdBy {
        ... on User {
          fullName
        }
      }
      updatedBy {
        ... on User {
          fullName
        }
      }
    }
  }
}
`;

export interface AutomationDetailResponse {
  automationList: {
    automations: AutomationType[];
  };
}
